import { render, staticRenderFns } from "./MonitorMessage.vue?vue&type=template&id=97f2ddbc&"
import script from "./MonitorMessage.vue?vue&type=script&lang=js&"
export * from "./MonitorMessage.vue?vue&type=script&lang=js&"
import style0 from "./MonitorMessage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports